import { logger } from '@/util/logger';

const $ = window.$;

export default function (id, settings) {
	this.$outer = $('#' + id);
	var that = this;
	var s = settings || {};

	var _$fields = this.$outer.find('.js-validation-field');
	var _$submitBtn = this.$outer.find('.js-validation-submit');
	var _$resetBtn = this.$outer.find('.js-validation-reset');

	var _isInvalidState = true;

	var _validationMethods = {
		required: function (value) {
			return Boolean(value.trim());
		},
		positiveNumber: function (value) {
			return isNaN(value) === false && value > 0;
		},
		maxLength: function (value, numCharacters) {
			return value.length <= numCharacters;
		},
		minLength: function (value, numCharacters) {
			return value.length >= numCharacters;
		}
	};

	var _fieldSettings = settings.fields || {};

	this.validateInput = function ($input, inputValue, cancelFormValidation) {
		var value = inputValue ? inputValue : $input.val();
		// basic validation, if no other validation types are specified
		var isValid = true;

		// get validation rules or assume the field is just required
		var fieldSettings = _fieldSettings[$input.data().field] || {};

		if (fieldSettings.rules) {
			var fieldRules = fieldSettings.rules;
			for (let rule in fieldRules) {
				if (fieldRules.hasOwnProperty(rule)) {
					var method = _validationMethods[rule];
					var ruleValue = fieldRules[rule];

					if (method) {
						isValid = method(value, ruleValue);
					} else {
						logger.warn('No validation rule named ' + rule);
					}

					if (!isValid) break;
				}
			}
		} else {
			isValid = _validationMethods.required(value);
		}

		if (isValid && !$input.hasClass('is-valid')) {
			$input.addClass('is-valid');
			window._numValid++;
		}

		if (!isValid && $input.hasClass('is-valid')) {
			$input.removeClass('is-valid');
			window._numValid--;
		}
		// run field settings callback prior to validating form
		if (typeof fieldSettings.callback === 'function') {
			fieldSettings.callback();
		}

		if (!cancelFormValidation) {
			this.validateForm();
		}

		return isValid;
	};

	this.validateInputDebounced = window.debounce(this.validateInput, 100);

	this.validateForm = function (isInitialValidation) {
		var $requiredFields = _$fields.not('.js-validation-ignore');
		var isValid = $requiredFields.filter('.is-valid').length === $requiredFields.length;

		if (isValid) {
			if (isInitialValidation || _isInvalidState) {
				// do any generic validation stuff
				if (typeof s.onValid === 'function') s.onValid(that);

				_isInvalidState = false;
			}
		} else {
			if (isInitialValidation || !_isInvalidState) {
				// do any generic invalidation stuff
				if (typeof s.onInvalid === 'function') s.onInvalid(that);

				_isInvalidState = true;
			}
		}
	};

	var _validateCheckboxGroup = function ($checkboxGroup, $checkboxes, cancelFormValidation) {
		var values = [];
		$checkboxes.filter(':checked').each(function () {
			values.push($(this).val());
		});

		this.validateInput($checkboxGroup, values.join(','), cancelFormValidation);
	};

	var _validateRadioGroup = function ($radioGroup, cancelFormValidation) {
		var $selected = $radioGroup.find('input[type=radio]:checked');
		var val = $selected.length ? $selected.val() : null;

		this.validateInput($radioGroup, val, cancelFormValidation);
	};

	var _cacheSelectors = function () {
		this.$outer = $('#' + id);

		_$fields = this.$outer.find('.js-validation-field');
		_$submitBtn = this.$outer.find('.js-validation-submit');
		_$resetBtn = this.$outer.find('.js-validation-reset');
	};

	this.validateAll = function () {
		_$fields.each(function () {
			// validate each field, but don't validate the entire form each time, because we'll do it at the end.
			$(this).trigger('validate', [true]);
		});

		this.validateForm(true);
	};

	this.resetAll = function () {
		_$fields.each(function () {
			$(this).trigger('reset');
		});

		if (typeof s.onReset === 'function') s.onReset();

		this.validateForm();
	};

	this.disableSubmit = function () {
		_$submitBtn
			.addClass('btn--disabled')
			.attr('disabled', 'true');
	};

	this.enableSubmit = function () {
		_$submitBtn
			.removeClass('btn--disabled')
			.removeAttr('disabled', 'true');
	};

	var _attachEvents = function () {
		var $textInputs = _$fields.filter('input[type=text], input[type=hidden], input[type=password], textarea');
		var $checkboxInputs = _$fields.filter('[data-field-type="checkbox"]');
		var $radioInputs = _$fields.filter('[data-field-type="radio"]');
		var $dropdowns = _$fields.filter('select');

		$textInputs
			.on('keyup', function () {
				that.validateInputDebounced($(this));
			})
			.on('input', function () {
				that.validateInputDebounced($(this));
			})
			.on('blur', function (e, cancelFormValidation) {
				that.validateInput($(this), $(this).val(), cancelFormValidation);
			})
			.on('validate', function (e, cancelFormValidation) {
				that.validateInput($(this), $(this).val(), cancelFormValidation);
			})
			.on('reset', function () {
				this.value = '';
				that.validateInput($(this));
			});

		$dropdowns.on('change validate', function (e, cancelFormValidation) {
			that.validateInput($(this), $(this).val(), cancelFormValidation);
		});

		$radioInputs.each(function () {
			var $radioGroup = $(this);
			var $radioButtons = $radioGroup.find('input[type=radio]');

			$radioGroup.on('validate', function (e, cancelFormValidation) {
				_validateRadioGroup.call(that, $radioGroup, cancelFormValidation);
			});

			$radioButtons.on('change', function () {
				_validateRadioGroup.call(that, $radioGroup);
			});

			$radioGroup.on('reset', function () {
				$radioButtons.each(function () {
					this.checked = false;
				});
				_validateRadioGroup.call(that, $radioGroup);
			});
		});

		$checkboxInputs.each(function () {
			var $checkboxGroup = $(this);
			var $checkboxes = $checkboxGroup.find('input[type=checkbox]');

			$checkboxGroup.on('validate', function () {
				_validateCheckboxGroup.call(that, $checkboxGroup, $checkboxes);
			});

			$checkboxes.on('change', function () {
				_validateCheckboxGroup.call(that, $checkboxGroup, $checkboxes);
			});

			$checkboxGroup.on('reset', function () {
				$checkboxes.each(function () {
					this.checked = false;
				});
			});
		});

		_$resetBtn.on('click', function () {
			that.resetAll();
		});
	};

	this.init = function () {
		_cacheSelectors.call(this);
		_attachEvents.call(this);

		if (s.validateOnLoad) {
			this.validateAll();
		}
	};
}